/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Reference_Response_TitleInputs */

const en_endpoint_reference_response_title = /** @type {(inputs: Endpoint_Reference_Response_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Response`)
};

const zh_hans1_endpoint_reference_response_title = /** @type {(inputs: Endpoint_Reference_Response_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`响应`)
};

const pt_br2_endpoint_reference_response_title = /** @type {(inputs: Endpoint_Reference_Response_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resposta`)
};

const es_endpoint_reference_response_title = /** @type {(inputs: Endpoint_Reference_Response_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respuesta`)
};

const fr_endpoint_reference_response_title = /** @type {(inputs: Endpoint_Reference_Response_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réponse`)
};

const de_endpoint_reference_response_title = /** @type {(inputs: Endpoint_Reference_Response_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antwort`)
};

const ru_endpoint_reference_response_title = /** @type {(inputs: Endpoint_Reference_Response_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ответ`)
};

const it_endpoint_reference_response_title = /** @type {(inputs: Endpoint_Reference_Response_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risposta`)
};

/**
* | output |
* | --- |
* | "Response" |
*
* @param {Endpoint_Reference_Response_TitleInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_reference_response_title = /** @type {((inputs?: Endpoint_Reference_Response_TitleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Reference_Response_TitleInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_reference_response_title(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_reference_response_title(inputs)
	if (locale === "es") return es_endpoint_reference_response_title(inputs)
	if (locale === "fr") return fr_endpoint_reference_response_title(inputs)
	if (locale === "de") return de_endpoint_reference_response_title(inputs)
	if (locale === "ru") return ru_endpoint_reference_response_title(inputs)
	if (locale === "it") return it_endpoint_reference_response_title(inputs)
	return en_endpoint_reference_response_title(inputs)
});